<template>
    <el-dialog title="高级设置" :model-value="props.modelValue" @closed="closed" width="840px" :close-on-click-modal="false">
        <!-- 高级设置 -->
        <el-form :model="setForm" label-width="160px" label-position="right" ref="setupForm" :rules="rules">
            <el-row justify="space-between">
                <el-col :span="11">
                    <el-form-item label="设定温度（摄氏度）">
                        <el-input-number
                            v-model="setForm.set_temp"
                            :min="5"
                            :max="35"
                            controls-position="right"
                            @change="(val) => handleFieldChange(val, 'set_temp')"
                        />
                        &nbsp;℃
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="运行模式">
                        <el-select v-model="setForm.set_run_mode" @change="(val) => handleFieldChange(val, 'set_run_mode')">
                            <template v-for="item in run_mode" :key="item._id">
                                <el-option :label="item.label" :value="item.value"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="设置温度锁定上限">
                        <el-input-number
                            v-model="setForm.upper"
                            :min="5"
                            :max="35"
                            controls-position="right"
                            @change="(val) => handleFieldChange(val, 'upper')"
                        />
                        &nbsp;℃
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="风速设置">
                        <el-select v-model="setForm.set_wind_speed" @change="(val) => handleFieldChange(val, 'set_wind_speed')">
                            <template v-for="item in speed" :key="item._id">
                                <el-option :label="item.label" :value="item.value"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="设置温度锁定下限">
                        <el-input-number
                            v-model="setForm.floor"
                            :min="5"
                            :max="35"
                            controls-position="right"
                            @change="(val) => handleFieldChange(val, 'floor')"
                        />
                        &nbsp;℃
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="锁定状态">
                        <el-select v-model="setForm.set_lock" @change="(val) => handleFieldChange(val, 'set_lock')">
                            <template v-for="item in lockOptions" :key="item._id">
                                <el-option :label="item.label" :value="item.value"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="温度补偿">
                        <el-input-number
                            v-model="setForm.temp_compensation"
                            :min="-9"
                            :max="9"
                            controls-position="right"
                            @change="(val) => handleFieldChange(val, 'temp_compensation')"
                        />
                        &nbsp;℃
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="同步方式">
                        <el-select v-model="setForm.sync_type" @change="(val) => handleFieldChange(val, 'sync_type')">
                            <template v-for="item in syncMode" :key="item._id">
                                <el-option :label="item.label" :value="item.value"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="湿度补偿">
                        <el-input-number
                            v-model="setForm.hum_compensation"
                            :min="-20"
                            :max="20"
                            controls-position="right"
                            @change="(val) => handleFieldChange(val, 'hum_compensation')"
                        />
                        &nbsp;%
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="房卡使能" prop="room_card">
                        <el-select v-model="setForm.room_card" @change="(val) => handleFieldChange(val, 'room_card')">
                            <template v-for="item in room_card_status" :key="item._id">
                                <el-option :label="item.label" :value="item.value"></el-option>
                            </template>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="节能模式" prop="set_energy">
                        <el-switch
                            v-model="setForm.set_energy"
                            :active-value="1"
                            :inactive-value="0"
                            active-text="开"
                            inactive-text="关"
                            @change="(val) => handleSwitchChange(val, 'set_energy')"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="计费使能" prop="main_ac">
                        <el-switch
                            v-model="setForm.main_ac"
                            :active-value="1"
                            :inactive-value="0"
                            active-text="使能"
                            inactive-text="不使能"
                            @change="(val) => handleSwitchChange(val, 'main_ac')"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="时间设置" prop="timeGroup">
                        <div v-for="(stage, index) in timeStages" :key="index" class="time-group-item">
                            <el-time-picker
                                v-model="stage.start"
                                placeholder="开始时间"
                                format="HH:mm"
                                value-format="HH:mm"
                                @change="handleTimeGroupChange"
                                @clear="() => handleTimeClear(index)"
                                clearable
                                style="width: 48%; margin-right: 4%; margin-bottom: 10px"
                            />
                            <el-time-picker
                                v-model="stage.end"
                                placeholder="结束时间"
                                format="HH:mm"
                                value-format="HH:mm"
                                @change="handleTimeGroupChange"
                                @clear="() => handleTimeClear(index)"
                                clearable
                                style="width: 48%; margin-bottom: 10px"
                            />
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">关闭</el-button>
                <!-- <el-button type="primary" :loading="submitLoading" @click="onConfirm">确认</el-button> -->
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, defineProps, defineExpose, reactive, defineEmits, onMounted, watch } from 'vue'
import { batchPatchValveParams } from '@/api/thermostat/devicePoint.js'
import { lockOptions, speed, run_mode, room_card_status } from '@/constant/index.js'
import { ElMessage } from 'element-plus'
/**
 * @param model 温控器型号
 * @param thermostatId  温控器ID
 * @param isForm true 可编辑 false 禁用
 * @param setForm 表单数据
 */
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    formDatail: {
        type: Object,
        required: false
    },
    formIds: {
        type: Array,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])
let isMounted = false
// 防抖函数：避免频繁请求
const debounce = (fn, delay = 300) => {
    let timer = null
    return (...args) => {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
            fn(...args)
        }, delay)
    }
}
const submitLoading = ref(false)
const setForm = ref({
    set_switch: '',
    set_temp: '',
    set_run_mode: '',
    set_wind_speed: '',
    set_energy: '',
    restart: '',
    set_lock: '',
    upper: 35,
    floor: 5,
    cum_enable: '',
    temp_cold: 25,
    temp_heat: 35,
    temp_compensation: 0,
    hum_compensation: 0,
    server_url: '',
    server_port: '',
    connect_username: '',
    connect_pwd: '',
    period: '',
    sync_type: '',
    main_ac: '',
    room_card: ''
})
const timeStages = ref([
    { start: '00:00', end: '09:00' },
    { start: '09:00', end: '12:00' },
    { start: '12:00', end: '20:00' },
    { start: '20:00', end: '00:00' }
])
const setupForm = ref(null)
// 时间变化触发校验
function handleTimeChange() {
    setupForm.value?.validateField('timeGroup')
}

// 3. 时间段校验 - 保持原有逻辑
function validateTimeGroup(rule, value, callback) {
    const filledList = timeStages.value.filter((item) => item.start && item.end)
    if (filledList.length > 0 && filledList.length < 4) {
        callback(new Error('填写任意一个时间段后，必须填写全部4个时间段'))
    } else {
        callback()
    }
}

function checkTimeCoverage() {
    const fields = timeStages.value
    if (fields.some((ele) => ele.start || ele.end)) {
        // 校验每个时间段完整性和合法性
        for (let i = 0; i < fields.length; i++) {
            const item = fields[i]
            if (!item.start || !item.end) {
                ElMessage.error(`第${i + 1}个时间段请选择完整的开始和结束时间`)
                return false
            }
            if (item.start === item.end) {
                ElMessage.error(`第${i + 1}个时间段的开始时间不能等于结束时间`)
                return false
            }
        }
        // 校验首尾和衔接
        if (fields[0].start !== '00:00') {
            ElMessage.error('时间段必须从 00:00 开始')
            return false
        }
        if (fields[3].end !== '00:00') {
            ElMessage.error('第4个时间段的结束时间必须为 00:00')
            return false
        }
        for (let i = 0; i < fields.length - 1; i++) {
            if (fields[i].end !== fields[i + 1].start) {
                ElMessage.error(`第${i + 1}个时间段的结束时间，必须等于第${i + 2}个时间段的开始时间`)
                return false
            }
        }
    }
    return true
}
// 4. 时间段清空 - 数组版
function handleTimeClear(index) {
    timeStages.value[index] = { start: '', end: '' }
    handleTimeGroupChange()
}
// 5. 核心：单个表单项变化提交
const submitSingleField = debounce(async (fieldName, fieldValue) => {
    const params = {
        [fieldName]: fieldValue
    }
    if (props.formIds.length) params.id_list = props.formIds
    try {
        await batchPatchValveParams(params)
        ElMessage.success('设置成功')
    } catch (error) {
        ElMessage.error('设置失败')
    }
})
const handleFieldChange = (val, key) => {
    if (!isMounted) return // 挂载未完成，不处理
    // 处理 el-input-number/el-select：从 event.target.dataset 获取 key
    if (!key) {
        key = event.target.dataset.key
    }
    // 触发提交
    submitSingleField(key, val)
}
const handleSwitchChange = (val, key) => {
    console.log("🚀 ~ handleSwitchChange ~ val, key:", val, key)
    if (!isMounted) return // 组件初始化触发的change，直接跳过
    submitSingleField(key, val)
}
// 6. 核心：时间段变化提交（校验通过后提交4个时间段）
const submitTimeGroup = debounce(async () => {
    if (!checkTimeCoverage()) return
    const params = {
        tStage1: `${timeStages.value[0].start}-${timeStages.value[0].end}`,
        tStage2: `${timeStages.value[1].start}-${timeStages.value[1].end}`,
        tStage3: `${timeStages.value[2].start}-${timeStages.value[2].end}`,
        tStage4: `${timeStages.value[3].start}-${timeStages.value[3].end}`
    }
    if (props.formIds.length) params.id_list = props.formIds
    try {
        await batchPatchValveParams(params)
        ElMessage.success('时间段提交成功')
        // emits('updateForm')
    } catch (error) {
        ElMessage.error('时间段提交失败')
    }
})
const handleTimeGroupChange = () => {
    setupForm.value?.validateField('timeGroup')
    submitTimeGroup()
}

// 8. 监听时间段字段修正空值
watch(
    timeStages,
    (newVals) => {
        newVals.forEach((val) => {
            if (val.start === null) val.start = ''
            if (val.end === null) val.end = ''
        })
    },
    { deep: true }
)

// 表单校验规则
const rules = ref({
    timeGroup: [
        {
            validator: validateTimeGroup,
            trigger: 'change'
        }
    ]
})

// 监听时间字段变化，兜底修正异常值
watch(
    timeStages,
    (newVals) => {
        newVals.forEach((val) => {
            // 确保 start/end 为字符串或空
            if (val.start === null) val.start = ''
            if (val.end === null) val.end = ''
        })
    },
    { deep: true }
)
onMounted(() => {
    if (props.formDatail) {
        for (const key in setForm.value) {
            if (key !== 'id') {
                setForm.value[key] = props.formDatail?.[key] || setForm.value[key]
            }
        }
        // 时间段数据回显
        for (let i = 0; i < 4; i++) {
            const stageKey = `tStage${i + 1}`
            if (props.formDatail[stageKey]) {
                const [start, end] = props.formDatail[stageKey].split('-')
                timeStages.value[i] = { start, end }
            }
        }
    }
    setTimeout(() => {
        isMounted = true
    }, 0)
})
const closed = () => {
    emits('update:modelValue', false)
}
const syncMode = reactive([
    { label: '异步', value: 1 },
    { label: '同步', value: 2 }
])
// defineExpose({ setForm })
</script>

<style></style>
